import axios from "axios";
let baseUrl =  "https://api-game-box.gameyiming.com/"
if (process.env.NODE_ENV === "development") {
  //武汉本地测试地址
  baseUrl = "http://192.168.10.12:8787";
  // baseUrl = "https://api-game-box.gameyiming.com/";
}
//外网调试地址
// const baseUrl = "http://test-api-box.freegame4.com"



//1.常规请求的axios
const request = axios.create({
  baseURL: process.env.VUE_APP_API + "",
  //baseURL: baseUrl, //武汉本地测试地址
  timeout: 5000,
});


export { request, baseUrl };
